import { roundToX } from "@lib/util"

async function calculatePrice(prices) {
  const errorLines = [],
    eurPrices = [],
    chfPrices = []
  const pricesArray = prices.split("\n")

  const RESELLER_MARGIN = 0.5
  const ELITE_COEF = 0.7
  const VAT = 1.081
  const EUR_COEF = 1.18

  for (let i = 0; i < pricesArray.length; i++) {
    // replace comma with dot, remove all non-numeric characters
    const cleanPrice = pricesArray[i]
      .trim()
      .replace(/[,]+/g, ".")
      .replace(/[^0-9-.]/g, "")

    // skip error when pasting with a new line at the end
    if (i === pricesArray.length - 1 && cleanPrice === "") {
      continue
    }
    // check for error
    if (cleanPrice < 0 || cleanPrice === "" || (isNaN(cleanPrice) && cleanPrice !== "-")) {
      errorLines.push(i + 1)
    } else {
      // skip calculation if price is "-"
      if (cleanPrice === "-") {
        chfPrices.push(cleanPrice)
        eurPrices.push(cleanPrice)
        continue
      }
      // formula based on this excel file:
      // \Marketing_et_Communication\03-MarketingParActivité\09-Partenariat\09-Atelier L&B\_Linge_de_lit_Elite_2022_configurateur.xlsx
      const chfPrice = roundToX((cleanPrice / RESELLER_MARGIN / ELITE_COEF) * VAT, 5)
      const euroPrice = roundToX(chfPrice * EUR_COEF, 5)
      chfPrices.push(chfPrice - (chfPrice % 5))
      eurPrices.push(euroPrice)
    }
  }

  // return error if any, else return the final prices
  if (errorLines.length > 0) {
    return { error: `Error on line(s): ${errorLines.join(", ")}` }
  } else {
    return {
      eur: eurPrices.join("\n"),
      chf: chfPrices.join("\n")
    }
  }
}

export default calculatePrice
